enum ProductId {
  Banners = 'banners',
  SearchWidget = 'search',
}

export { ProductId };
